import React from 'react'

import { useAuth } from './Auth/use-auth'
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer'
import Button from '@material-ui/core/Button'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import CloudOff from '@material-ui/icons/CloudOff'
import MenuIcon from '@material-ui/icons/Menu'
import FaceOutlinedIcon from '@material-ui/icons/FaceOutlined'
import PermContactCalendarOutlinedIcon from '@material-ui/icons/PermContactCalendarOutlined'
import CloudCircleOutlinedIcon from '@material-ui/icons/CloudCircleOutlined'
import { Link, useHistory } from 'react-router-dom'

export default function SwipeableTemporaryDrawer (props) {
  const [state, setState] = React.useState({ left: false })
  const toggleDrawer = (anchor, open) => event => {
    if (
      event &&
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return
    }

    setState({ ...state, [anchor]: open })
  }
  const history = useHistory()
  const auth = useAuth()

  console.log('drawer props', props)

  const list = anchor => (
    <div
      key={444}
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List key={333}>
        <ListItem button key={111}>
          <ListItemIcon>
            <FaceOutlinedIcon color={'primary'} />
          </ListItemIcon>
          <Link to={`/groupsCRUD`}>
            <ListItemText primary={'Töötajad'} />
          </Link>
        </ListItem>
        <ListItem button key={2222}>
          <ListItemIcon>
            <PermContactCalendarOutlinedIcon color={'primary'} />
          </ListItemIcon>
          <Link to={`/clientCRUD`}>
            <ListItemText primary={'Kliendid'} />
          </Link>
        </ListItem>
        <ListItem button key={2225}>
          <ListItemIcon>
            <PermContactCalendarOutlinedIcon color={'primary'} />
          </ListItemIcon>
          <Link to={`/printquery`}>
            <ListItemText primary={'Aruanded'} />
          </Link>
        </ListItem>
        <ListItem button key={2223}>
          <ListItemIcon>
            <CloudCircleOutlinedIcon color={'primary'} />
          </ListItemIcon>
          <Link to={`/`}>
            <ListItemText primary={'Logi sisse'} />
          </Link>
        </ListItem>
      </List>
    </div>
  )
  const handleLogOut = () => {
    auth.signout()
    history.push('/')
  }
  return (
    <React.Fragment>
      <Button id={'drwbutton'} onClick={toggleDrawer('left', true)}>
        <MenuIcon />
      </Button>
      <SwipeableDrawer
        id={'swd'}
        anchor={'left'}
        open={state['left']}
        onClose={toggleDrawer('left', false)}
        onOpen={toggleDrawer('left', true)}
      >
        {list('left')}
        <Button id={'logout'} onClick={handleLogOut}>
          <CloudOff color={'primary'} />
          {'  '}
          Logi Valja
        </Button>
      </SwipeableDrawer>
    </React.Fragment>
  )
}
